<template>
  <q-expansion-item
      v-bind="$attrs"
      :aria-expanded="expanded"
      @click="expanded = !expanded"
  >
    <template v-slot:header>
      <q-item-section>
        <slot name="header">
          {{ label }}
        </slot>
      </q-item-section>
    </template>
    <slot />
  </q-expansion-item>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      expanded: false
    }
  }
}
</script>